/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { BidderStatsDto } from '../models/bidder-stats-dto';

@Injectable({
  providedIn: 'root',
})
export class GeneratedBidderStatsService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation getBidderStats
   */
  static readonly GetBidderStatsPath = '/api/bidder-stats/{bidderIds}';

  /**
   * Gets statistics about one or more bidders.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getBidderStats()` instead.
   *
   * This method doesn't expect any request body.
   */
  getBidderStats$Response(params: {
    bidderIds: string;
    'X-API-Version'?: string;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<Array<BidderStatsDto>>> {

    const rb = new RequestBuilder(this.rootUrl, GeneratedBidderStatsService.GetBidderStatsPath, 'get');
    if (params) {
      rb.path('bidderIds', params.bidderIds, {});
      rb.header('X-API-Version', params['X-API-Version'], {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<BidderStatsDto>>;
      })
    );
  }

  /**
   * Gets statistics about one or more bidders.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getBidderStats$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getBidderStats(params: {
    bidderIds: string;
    'X-API-Version'?: string;
  },
  context?: HttpContext

): Observable<Array<BidderStatsDto>> {

    return this.getBidderStats$Response(params,context).pipe(
      map((r: StrictHttpResponse<Array<BidderStatsDto>>) => r.body as Array<BidderStatsDto>)
    );
  }

}
